import React, { Fragment } from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function QuoteStepHeader({
  steps,
  currentStep,
  onChangeStep
}) {
  return <div className="mb-8" data-id="element-4820">
      <div className="flex items-center justify-center" data-id="element-4821">
        {steps.map((step, index) => <Fragment key={index} data-id="element-4822">
            <div className={`relative flex flex-col items-center group ${index <= currentStep ? 'cursor-pointer' : 'cursor-not-allowed'}`} onClick={() => index <= currentStep && onChangeStep(index)} data-id="element-4823">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${index < currentStep ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-md' : index === currentStep ? 'bg-white text-indigo-900 shadow-md' : 'bg-slate-700/50 text-slate-400'}`} data-id="element-4824">
                {step.icon || index + 1}
              </div>
              <div className={`absolute -bottom-6 whitespace-nowrap text-xs font-medium ${index <= currentStep ? 'text-indigo-200' : 'text-slate-500'}`} data-id="element-4825">
                {step.label}
              </div>
            </div>
            {index < steps.length - 1 && <div className={`w-16 h-1 mx-1 ${index < currentStep ? 'bg-gradient-to-r from-indigo-500 to-purple-600' : 'bg-slate-700/50'}`} data-id="element-4826"></div>}
          </Fragment>)}
      </div>
      <div className="h-6" data-id="element-4827"></div>
    </div>;
}